import type { RootState } from '@/store/store';

export const selectThemeMode = (state: RootState) => state.theme.mode;
